// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/approval_flow_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ApprovalMode, ApprovalStrategy, BusinessProcess, PlanningSection, SwitchReason, WorkflowSchedule } from "../../bfftypes/v1/approval_flow_type_pb";
import { file_bfftypes_v1_approval_flow_type } from "../../bfftypes/v1/approval_flow_type_pb";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Empty, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/approval_flow_model.proto.
 */
export const file_bffuser_v1_approval_flow_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_approval_flow_type, file_bfftypes_v1_area, file_bfftypes_v1_side, file_buf_validate_validate, file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_type_decimal]);

/**
 * ApprovalFlowProcessSetting holds the complete approval flow configuration
 * for one business process. Mirrors backend internalapi.v1.ApprovalFlowProcessSetting;
 * organization_id is absent (resolved from eauth session by BFF).
 *
 * @generated from message bffuser.v1.ApprovalFlowProcessSetting
 */
export type ApprovalFlowProcessSetting = Message<"bffuser.v1.ApprovalFlowProcessSetting"> & {
  /**
   * @generated from field: bfftypes.v1.BusinessProcess business_process = 1;
   */
  businessProcess: BusinessProcess;

  /**
   * @generated from field: repeated bffuser.v1.ApprovalFlowCell cells = 2;
   */
  cells: ApprovalFlowCell[];

  /**
   * @generated from field: repeated bffuser.v1.AutoSwitchCondition conditions = 3;
   */
  conditions: AutoSwitchCondition[];

  /**
   * updated_at is used as the expected_updated_at baseline when saving.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;

  /**
   * auto_bid_rules lists the 自動入札ルール (設定層) configured for the
   * 自動 (AUTO) approval-mode areas of this business process.
   *
   * @generated from field: repeated bffuser.v1.AutoBidRule auto_bid_rules = 5;
   */
  autoBidRules: AutoBidRule[];

  /**
   * auto_bid_rules_basis_unselected lists the sides whose saved rule is opened
   * with its 基準 unselected (AC-APF-076). Such a side counts as not saved, so
   * it never appears in auto_bid_rules; a (area_code, bid_side) is in at most
   * one of the two.
   *
   * @generated from field: repeated bffuser.v1.AutoBidRuleBasisUnselected auto_bid_rules_basis_unselected = 6;
   */
  autoBidRulesBasisUnselected: AutoBidRuleBasisUnselected[];
};

/**
 * Describes the message bffuser.v1.ApprovalFlowProcessSetting.
 * Use `create(ApprovalFlowProcessSettingSchema)` to create a new message.
 */
export const ApprovalFlowProcessSettingSchema: GenMessage<ApprovalFlowProcessSetting> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 0);

/**
 * SpotBidConfig mirrors backend internalapi.v1.SpotBidConfig.
 *
 * @generated from message bffuser.v1.SpotBidConfig
 */
export type SpotBidConfig = Message<"bffuser.v1.SpotBidConfig"> & {
  /**
   * @generated from field: bffuser.v1.AutoBidOrderMethod order_method = 1;
   */
  orderMethod: AutoBidOrderMethod;

  /**
   * limit_price_yen_per_kwh is present only when order_method =
   * AUTO_BID_ORDER_METHOD_LIMIT (0.01-999 円/kWh).
   *
   * @generated from field: optional google.type.Decimal limit_price_yen_per_kwh = 2;
   */
  limitPriceYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.SpotBidConfig.
 * Use `create(SpotBidConfigSchema)` to create a new message.
 */
export const SpotBidConfigSchema: GenMessage<SpotBidConfig> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 1);

/**
 * IntradayBidConfig mirrors backend internalapi.v1.IntradayBidConfig.
 *
 * @generated from message bffuser.v1.IntradayBidConfig
 */
export type IntradayBidConfig = Message<"bffuser.v1.IntradayBidConfig"> & {
  /**
   * @generated from field: bffuser.v1.IntradayPriceMode price_mode = 1;
   */
  priceMode: IntradayPriceMode;

  /**
   * basis is present only when price_mode = INTRADAY_PRICE_MODE_DETERMINE.
   *
   * @generated from field: optional bffuser.v1.IntradayBasis basis = 2;
   */
  basis?: IntradayBasis;

  /**
   * fixed_price_yen_per_kwh is present only when basis =
   * INTRADAY_BASIS_FIXED (0.01-999 円/kWh).
   *
   * @generated from field: optional google.type.Decimal fixed_price_yen_per_kwh = 3;
   */
  fixedPriceYenPerKwh?: Decimal;

  /**
   * adjustment_yen_per_kwh (手数料等) is always required (-999-999 円/kWh).
   *
   * @generated from field: google.type.Decimal adjustment_yen_per_kwh = 4;
   */
  adjustmentYenPerKwh?: Decimal;

  /**
   * counter_ref_price_yen_per_kwh / bid_price_yen_per_kwh are present only
   * when price_mode = INTRADAY_PRICE_MODE_SNAP_UP (0.01-999 円/kWh each).
   *
   * @generated from field: optional google.type.Decimal counter_ref_price_yen_per_kwh = 5;
   */
  counterRefPriceYenPerKwh?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal bid_price_yen_per_kwh = 6;
   */
  bidPriceYenPerKwh?: Decimal;

  /**
   * spot_reference is the 参照エリア, present only when basis =
   * INTRADAY_BASIS_SPOT_AREA_PRICE (one of the 9 areas but 沖縄). A response
   * always carries reference_area_code; same_as_target_area (each saved area's
   * own area) is for a save request only.
   *
   * @generated from oneof bffuser.v1.IntradayBidConfig.spot_reference
   */
  spotReference: {
    /**
     * @generated from field: google.protobuf.Empty same_as_target_area = 7;
     */
    value: Empty;
    case: "sameAsTargetArea";
  } | {
    /**
     * @generated from field: bfftypes.v1.AreaCode reference_area_code = 8;
     */
    value: AreaCode;
    case: "referenceAreaCode";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.IntradayBidConfig.
 * Use `create(IntradayBidConfigSchema)` to create a new message.
 */
export const IntradayBidConfigSchema: GenMessage<IntradayBidConfig> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 2);

/**
 * AutoBidRule mirrors backend internalapi.v1.AutoBidRule;
 * organization_id is absent (resolved from eauth session by BFF).
 * process_config carries the process-specific fields (former flat fields
 * 4/5 — order_method / limit_price_yen_per_kwh — moved into SpotBidConfig).
 *
 * @generated from message bffuser.v1.AutoBidRule
 */
export type AutoBidRule = Message<"bffuser.v1.AutoBidRule"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.Side bid_side = 2;
   */
  bidSide: Side;

  /**
   * coverage_pct is the coverage ratio (%) applied to the coma-level
   * shortfall/surplus (0-100 integer).
   *
   * @generated from field: int32 coverage_pct = 3;
   */
  coveragePct: number;

  /**
   * @generated from oneof bffuser.v1.AutoBidRule.process_config
   */
  processConfig: {
    /**
     * @generated from field: bffuser.v1.SpotBidConfig spot = 6;
     */
    value: SpotBidConfig;
    case: "spot";
  } | {
    /**
     * @generated from field: bffuser.v1.IntradayBidConfig intraday = 7;
     */
    value: IntradayBidConfig;
    case: "intraday";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.AutoBidRule.
 * Use `create(AutoBidRuleSchema)` to create a new message.
 */
export const AutoBidRuleSchema: GenMessage<AutoBidRule> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 3);

/**
 * AutoBidRuleBasisUnselected mirrors backend internalapi.v1.AutoBidRuleBasisUnselected.
 *
 * @generated from message bffuser.v1.AutoBidRuleBasisUnselected
 */
export type AutoBidRuleBasisUnselected = Message<"bffuser.v1.AutoBidRuleBasisUnselected"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.Side bid_side = 2;
   */
  bidSide: Side;

  /**
   * coverage_pct is the saved coverage ratio (%) (0-100 integer).
   *
   * @generated from field: int32 coverage_pct = 3;
   */
  coveragePct: number;

  /**
   * adjustment_yen_per_kwh is the saved 基準からの調整 (-999-999 円/kWh).
   *
   * @generated from field: google.type.Decimal adjustment_yen_per_kwh = 4;
   */
  adjustmentYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.AutoBidRuleBasisUnselected.
 * Use `create(AutoBidRuleBasisUnselectedSchema)` to create a new message.
 */
export const AutoBidRuleBasisUnselectedSchema: GenMessage<AutoBidRuleBasisUnselected> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 4);

/**
 * ApprovalFlowCell represents one unit of approval-flow configuration.
 *
 * @generated from message bffuser.v1.ApprovalFlowCell
 */
export type ApprovalFlowCell = Message<"bffuser.v1.ApprovalFlowCell"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * section is optional; absent means the cell applies to all sections.
   *
   * @generated from field: optional bfftypes.v1.PlanningSection section = 2;
   */
  section?: PlanningSection;

  /**
   * schedule is optional; absent means the cell applies to all schedules.
   *
   * @generated from field: optional bfftypes.v1.WorkflowSchedule schedule = 3;
   */
  schedule?: WorkflowSchedule;

  /**
   * approval_mode is required. Cells without a configured mode are omitted
   * from the repeated list rather than being sent as UNSPECIFIED.
   *
   * @generated from field: bfftypes.v1.ApprovalMode approval_mode = 4;
   */
  approvalMode: ApprovalMode;

  /**
   * @generated from field: repeated bffuser.v1.ApprovalFlowStage stages = 5;
   */
  stages: ApprovalFlowStage[];
};

/**
 * Describes the message bffuser.v1.ApprovalFlowCell.
 * Use `create(ApprovalFlowCellSchema)` to create a new message.
 */
export const ApprovalFlowCellSchema: GenMessage<ApprovalFlowCell> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 5);

/**
 * ApprovalFlowStage represents a single stage within an approval flow cell.
 *
 * @generated from message bffuser.v1.ApprovalFlowStage
 */
export type ApprovalFlowStage = Message<"bffuser.v1.ApprovalFlowStage"> & {
  /**
   * @generated from field: int32 stage_order = 1;
   */
  stageOrder: number;

  /**
   * @generated from field: bfftypes.v1.ApprovalStrategy strategy = 2;
   */
  strategy: ApprovalStrategy;

  /**
   * @generated from field: repeated string approver_member_ids = 3;
   */
  approverMemberIds: string[];
};

/**
 * Describes the message bffuser.v1.ApprovalFlowStage.
 * Use `create(ApprovalFlowStageSchema)` to create a new message.
 */
export const ApprovalFlowStageSchema: GenMessage<ApprovalFlowStage> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 6);

/**
 * AutoSwitchCondition defines when the system automatically switches
 * approval mode for a given planning section.
 *
 * @generated from message bffuser.v1.AutoSwitchCondition
 */
export type AutoSwitchCondition = Message<"bffuser.v1.AutoSwitchCondition"> & {
  /**
   * @generated from field: bfftypes.v1.PlanningSection section = 1;
   */
  section: PlanningSection;

  /**
   * Range 0-100. Absent means no variance-based switching.
   *
   * @generated from field: optional int32 variance_threshold_percent = 2;
   */
  varianceThresholdPercent?: number;

  /**
   * deadline_minute_of_day triggers a switch when the clock reaches this
   * minute of the day (0-1439, where 0=00:00 and 1439=23:59) without
   * approval. Absent means no deadline-based switching.
   *
   * @generated from field: optional int32 deadline_minute_of_day = 3;
   */
  deadlineMinuteOfDay?: number;
};

/**
 * Describes the message bffuser.v1.AutoSwitchCondition.
 * Use `create(AutoSwitchConditionSchema)` to create a new message.
 */
export const AutoSwitchConditionSchema: GenMessage<AutoSwitchCondition> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 7);

/**
 * SwitchHistoryEntry records a single automatic approval-mode switch event.
 *
 * @generated from message bffuser.v1.SwitchHistoryEntry
 */
export type SwitchHistoryEntry = Message<"bffuser.v1.SwitchHistoryEntry"> & {
  /**
   * @generated from field: bfftypes.v1.BusinessProcess business_process = 1;
   */
  businessProcess: BusinessProcess;

  /**
   * @generated from field: optional bfftypes.v1.PlanningSection section = 2;
   */
  section?: PlanningSection;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.SwitchReason reason = 4;
   */
  reason: SwitchReason;

  /**
   * @generated from field: google.protobuf.Timestamp switched_at = 5;
   */
  switchedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SwitchHistoryEntry.
 * Use `create(SwitchHistoryEntrySchema)` to create a new message.
 */
export const SwitchHistoryEntrySchema: GenMessage<SwitchHistoryEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 8);

/**
 * ApproverCandidate represents a user who can be assigned as an approver.
 *
 * @generated from message bffuser.v1.ApproverCandidate
 */
export type ApproverCandidate = Message<"bffuser.v1.ApproverCandidate"> & {
  /**
   * @generated from field: string member_id = 1;
   */
  memberId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;
};

/**
 * Describes the message bffuser.v1.ApproverCandidate.
 * Use `create(ApproverCandidateSchema)` to create a new message.
 */
export const ApproverCandidateSchema: GenMessage<ApproverCandidate> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 9);

/**
 * AutoBidOrderMethod mirrors backend internalapi.v1.AutoBidOrderMethod.
 *
 * @generated from enum bffuser.v1.AutoBidOrderMethod
 */
export enum AutoBidOrderMethod {
  /**
   * @generated from enum value: AUTO_BID_ORDER_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUTO_BID_ORDER_METHOD_LIMIT = 1;
   */
  LIMIT = 1,

  /**
   * @generated from enum value: AUTO_BID_ORDER_METHOD_MARKET = 2;
   */
  MARKET = 2,
}

/**
 * Describes the enum bffuser.v1.AutoBidOrderMethod.
 */
export const AutoBidOrderMethodSchema: GenEnum<AutoBidOrderMethod> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_approval_flow_model, 0);

/**
 * IntradayPriceMode mirrors backend internalapi.v1.IntradayPriceMode.
 *
 * @generated from enum bffuser.v1.IntradayPriceMode
 */
export enum IntradayPriceMode {
  /**
   * @generated from enum value: INTRADAY_PRICE_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTRADAY_PRICE_MODE_DETERMINE = 1;
   */
  DETERMINE = 1,

  /**
   * @generated from enum value: INTRADAY_PRICE_MODE_SNAP_UP = 2;
   */
  SNAP_UP = 2,
}

/**
 * Describes the enum bffuser.v1.IntradayPriceMode.
 */
export const IntradayPriceModeSchema: GenEnum<IntradayPriceMode> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_approval_flow_model, 1);

/**
 * IntradayBasis mirrors backend internalapi.v1.IntradayBasis.
 *
 * @generated from enum bffuser.v1.IntradayBasis
 */
export enum IntradayBasis {
  /**
   * @generated from enum value: INTRADAY_BASIS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTRADAY_BASIS_BEST_QUOTE = 1;
   */
  BEST_QUOTE = 1,

  /**
   * @generated from enum value: INTRADAY_BASIS_LATEST_TRADE = 2;
   */
  LATEST_TRADE = 2,

  /**
   * @generated from enum value: INTRADAY_BASIS_FIXED = 4;
   */
  FIXED = 4,

  /**
   * 基準 = スポット: the 参照エリア's スポット市場のエリアプライス of the same 受渡日 and
   * koma (AC-APF-042). It takes IntradayBidConfig.spot_reference.
   *
   * @generated from enum value: INTRADAY_BASIS_SPOT_AREA_PRICE = 5;
   */
  SPOT_AREA_PRICE = 5,
}

/**
 * Describes the enum bffuser.v1.IntradayBasis.
 */
export const IntradayBasisSchema: GenEnum<IntradayBasis> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_approval_flow_model, 2);

